import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-lock",
  templateUrl: "./med-icon-lock.component.html",
})
export class MedIconLockComponent extends SvgMixinComponent {}
